import metricMetadataIcon from "../../assets/metric-metadata-icon-blue.svg";
import { useMetricMetadata } from "../../hooks/useMetricMetadata";
import { DisaggregatedMetric, GeoDetails, GeoTag } from "../../services/types";
import MetricMetadataModal from "../MetricMetadataModal";

interface MetricMetadataTriggerProps {
    metricId?: number;
    metricName: string;
    disaggData?: DisaggregatedMetric[] | null;
    geoDetails?: GeoDetails[];
    geoTag?: GeoTag | null;
    selectionActive?: boolean;
    showIcon?: boolean;
}

const MetricMetadataTrigger = ({
    metricId,
    metricName,
    disaggData = null,
    geoDetails = [],
    geoTag = null,
    selectionActive = false,
    showIcon = true,
}: MetricMetadataTriggerProps) => {
    const {
        showMetadata,
        toggleMetadata,
        metadata,
        distributionData,
        countyDistributionData,
        loading,
        error,
        triggerRef,
        modalId,
    } = useMetricMetadata({
        metricId,
        geoDetails,
        geoTag,
        enabled: showIcon,
    });

    if (!showIcon || !metricId) return null;

    return (
        <>
        <button
            ref={triggerRef}
            type="button"
            onClick={toggleMetadata}
            aria-haspopup="dialog"
            aria-expanded={showMetadata ? "true" : "false"}
            aria-controls={modalId}
            aria-label={`Additional information about ${metricName}`}
            className="
            inline-flex h-6 w-6 items-center justify-center rounded
            transition-transform hover:scale-105 focus:scale-105
            focus-visible:outline-none
            focus-visible:ring-2 focus-visible:ring-offset-2
            focus-visible:ring-neutral-900 focus-visible:ring-offset-white
            dark:focus-visible:ring-white dark:focus-visible:ring-offset-neutral-900
            "
        >
            <img
            src={metricMetadataIcon}
            alt=""
            aria-hidden="true"
            className="h-3 w-3"
            draggable="false"
            />
        </button>

        <MetricMetadataModal
            isOpen={showMetadata}
            onClose={toggleMetadata}
            id={metricId}
            metadata={metadata}
            disaggData={disaggData}
            stateData={null}
            nationalData={null}
            distributionData={distributionData}
            countyDistributionData={countyDistributionData}
            selectionActive={selectionActive}
            loading={loading}
            error={error}
            triggerRef={triggerRef}
            modalId={modalId}
        />
        </>
    );
};

export default MetricMetadataTrigger;